'use client';

import { useParams, usePathname } from 'next/navigation';

import { useGlobalStore } from '@/presenters/store/global';

import { useUserResources } from '../../user';

function useAnalyticsTags(isCategory: boolean): string[] {
  const { device, isOnMobileApp, region } = useGlobalStore((store) => ({
    region: store.session.region,
    isOnMobileApp: store.server.isOnMobileApp,
    device: store.server.device,
  }));

  const { data: isLoggedIn } = useUserResources((data) => data.isLoggedIn);

  const pathname = usePathname();
  const params = useParams();

  const analyticsTags: string[] = [];

  if (!region) {
    return analyticsTags;
  }

  if (pathname === '/search') {
    analyticsTags.push('#searchresults');
  }

  if (isCategory && params?.slug) {
    analyticsTags.push('#categorypage');
  }

  analyticsTags.push(`#${region}`);
  analyticsTags.push(isLoggedIn ? '#loginOn' : '#loginOff');
  analyticsTags.push(`#${isOnMobileApp ? 'app' : device}`);

  return analyticsTags;
}

export default useAnalyticsTags;
